import { ranks, topics } from '@/mocks/gossip';

const tagColor: Record<string, string> = {
  事件复盘: 'bg-secondary-100 text-secondary-900',
  技术鉴定: 'bg-accent-100 text-accent-800',
  图文证据: 'bg-primary-100 text-primary-800',
  影像解析: 'bg-accent-200 text-accent-900',
  投稿入口: 'bg-accent-500 text-background-50',
  线索整理: 'bg-secondary-200 text-secondary-900',
  聚合讨论: 'bg-primary-200 text-primary-900',
  综合研判: 'bg-secondary-100 text-secondary-900',
  方法科普: 'bg-accent-100 text-accent-800',
};

export default function RankingSection() {
  return (
    <section
      id="paixing"
      className="border-y border-background-200 bg-gradient-to-br from-background-100 via-background-200 to-background-100 py-14 md:py-20"
    >
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-5">
          {/* 热度榜单 */}
          <div className="lg:col-span-3">
            <div className="mb-6 flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  今日热度榜
                </h2>
                <p className="text-xs text-foreground-500">按关注热度实时排序，观察事件传播走向</p>
              </div>
            </div>

            <ol className="space-y-2">
              {ranks.map((item, idx) => (
                <li key={item.id}>
                  <a
                    href="#zhengju"
                    className="group flex items-center gap-3 rounded-lg bg-background-50 px-3 py-2.5 transition-colors hover:bg-background-50/90 sm:px-4"
                  >
                    <span
                      className={`font-label w-7 shrink-0 text-center text-lg font-bold ${
                        idx === 0
                          ? 'text-primary-500'
                          : idx === 1
                            ? 'text-primary-300'
                            : idx === 2
                              ? 'text-accent-500'
                              : 'text-background-400'
                      }`}
                    >
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm font-medium text-foreground-800 group-hover:text-primary-700">
                      {item.word}
                    </span>
                    <span className="hidden shrink-0 rounded-full px-2 py-0.5 text-[11px] whitespace-nowrap sm:inline-flex sm:items-center">
                      {item.category}
                    </span>
                    <span className="flex w-16 shrink-0 items-center justify-end gap-1.5">
                      <span className="h-1 flex-1 overflow-hidden rounded-full bg-background-200">
                        <span
                          className="block h-full rounded-full bg-primary-400"
                          style={{ width: `${item.heat}%` }}
                        />
                      </span>
                      <i
                        className={`text-xs ${
                          item.state === 'up'
                            ? 'text-primary-500'
                            : item.state === 'down'
                              ? 'text-foreground-400'
                              : item.state === 'new'
                                ? 'text-accent-500'
                                : 'text-background-400'
                        } ${
                          item.state === 'up'
                            ? 'ri-arrow-up-line'
                            : item.state === 'down'
                              ? 'ri-arrow-down-line'
                              : item.state === 'new'
                                ? 'ri-sparkling-line'
                                : 'ri-subtract-line'
                        }`}
                      />
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 热门话题 + 投稿引导 */}
          <div className="lg:col-span-2">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <i className="ri-chat-3-line text-lg text-accent-500" />
                <h3 className="font-heading text-lg font-bold text-foreground-950">话题风向</h3>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {topics.map((t) => (
                  <a
                    key={t.id}
                    href="#zhengju"
                    className="group inline-flex flex-col gap-1 rounded-lg border border-background-200 bg-background-50 px-3 py-2 transition-colors hover:border-accent-300 hover:bg-accent-50"
                  >
                    <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-800">
                      {t.name}
                    </span>
                    <span className="flex items-center gap-1.5 text-[11px] whitespace-nowrap text-foreground-500">
                      <i className="ri-chat-heart-line" />
                      {t.count}
                      <span className="ml-1 inline-flex items-center gap-0.5 text-accent-600">
                        <i className="ri-arrow-up-line" />
                        {t.trend}
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </div>

            <div
              id="tougao"
              className="mt-5 overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="aspect-[16/7] w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=stylized%20megaphone%20and%20message%20box%20with%20upload%20arrows%20illustration%2C%20warm%20cream%20background%2C%20bold%20coral%20and%20jade%20graphic%20shapes%2C%20anonymous%20submission%20campaign%2C%20flat%20editorial%20vector%2C%20high%20detail%2C%20no%20text&width=800&height=360&seq=gossip-submit-banner&orientation=landscape"
                  alt="匿名投稿入口宣传插画"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  手里有新素材？
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  图片、音频、文字线索均可投递，建议附带来源说明，帮助技术组更快完成交叉核验。
                </p>
                <a
                  href="#wenda"
                  className="mt-4 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-send-plane-line" />
                  了解投稿规则
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}